import React from 'react';
import { Box, Typography } from '@mui/material';
import { expandLeagueAbbreviation } from '@/utils/leagueUtils';

interface PlayerTeamInfoProps {
  playerName: string;
  description?: string;
  leagueName?: string;
}

const PlayerTeamInfo: React.FC<PlayerTeamInfoProps> = ({ playerName, description, leagueName }) => {
  return (
    <Box sx={{ mb: 2 }}>
      {/* Player name */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        👤 {playerName}
      </Typography>

      {/* League description */}
      {(description || leagueName) && (
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
          {description || (leagueName ? expandLeagueAbbreviation(leagueName) : '')}
        </Typography>
      )}
    </Box>
  );
};

export default PlayerTeamInfo;
